
import { GlobalController } from 'src/shared/global/GlobalController'
import BillingOrder from './BillingOrder'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'billingOrder',
    component: BillingOrder,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
